import { Message, MessageProps } from "primereact/message";
import React from "react";
import styled from "styled-components";
import { device } from "../../constants/mediaQueries";
import { useLocStore } from "../../localization";
import { LocContext } from "../../localization/LocContext";
import { useConsentsForCandidate } from "../../user/useConsentsForCandidate";
import { getRedirectProps } from "../../url/redirect";
import { CvpButton } from "../../generic-components/buttons/CvpButton";
import { withWSErrorContainer } from "../../error/withWSErrorContainer";

export interface MissingConsentMessageProps extends MessageProps {}

const _MissingConsentMessage = withWSErrorContainer(
  (props: MissingConsentMessageProps) => {
    const L = useLocStore(LocContext.MESSAGES);

    const { notActiveConsents } = useConsentsForCandidate();

    if (notActiveConsents.length === 0) return null;

    return (
      <Message
        severity="warn"
        text={
          <>
            <div>{L.id("bed2f6e2f33d").loc("Vi mangler ditt samtykke")}</div>
            <CvpButton
              label={L.id("02def82839c6").loc("Se samtykker")}
              text
              {...getRedirectProps("profile/privacy", {
                mergeQs: {},
              })}
            />
          </>
        }
        {...props}
      />
    );
  }
);

export const MissingConsentMessage = styled(_MissingConsentMessage)`
  width: 100%;

  .p-inline-message-text {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 0.9em;

    @media ${device.md} {
      font-size: 1rem;
    }
  }

  .cvp-button.cvp-button.cvp-button {
    padding: 0.25rem;

    .p-button-label {
      font-size: 0.9em;
    }
  }
`;
